var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 104.199,
    viewBox: "0 0 135 104.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4167",
    transform: "translate(-122.708 -81.669)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4163"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 62",
    d: "M2012.883 786.407s-1.233 2.311-2.019 3.792a30.734 30.734 0 0 1-54.31 0c-.785-1.481-2.018-3.792-2.018-3.792a32.61 32.61 0 0 1 4.36-3.84 5.646 5.646 0 0 1 7.631 2.34 19.445 19.445 0 0 0 34.366 0 5.645 5.645 0 0 1 7.63-2.34 32.591 32.591 0 0 1 4.36 3.84zm1.732-35.46a82.948 82.948 0 0 0-6.351-24.332c-.659-1.516-2.495-5.128-2.495-5.128s-3.591 1.619-4.933 2.2a5.645 5.645 0 0 0-2.926 7.427c.931 2.139 1.712 4.325 2.421 6.53a82.869 82.869 0 0 0-20.826-19.916c-1.336-.893-4.565-3.089-4.565-3.089s-2.426 3.394-3.262 4.65a5.644 5.644 0 0 0 1.56 7.828 72.282 72.282 0 0 1 8.2 6.372 47.616 47.616 0 0 0-13.252-1.9H1953.4v5.644a5.645 5.645 0 0 0 5.644 5.645h9.14a36.216 36.216 0 0 1 12.846 2.34 30.578 30.578 0 0 0-27.832 26.909 11.13 11.13 0 0 0-.056 1.048 9.045 9.045 0 0 0 6.128 2.65 5.647 5.647 0 0 0 5.5-4.383 19.444 19.444 0 0 1 37.886 0 5.648 5.648 0 0 0 5.5 4.383 9.043 9.043 0 0 0 6.128-2.65 93.91 93.91 0 0 0 .331-22.228z",
    transform: "translate(-1792.717 -632.973)",
    style: {
      fill: "#52dcb8"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 86",
    cx: 12,
    cy: 12.5,
    rx: 12,
    ry: 12.5,
    transform: "translate(233.708 160.867)",
    style: {
      fill: "#d7f6ee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 87",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(233.708 81.867)",
    style: {
      fill: "#d7f6ee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 88",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(122.708 132.867)",
    style: {
      fill: "#d7f6ee"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.6893cbf39196f21e9bb34ac7152b9cc6.svg";
export { ForwardRef as ReactComponent };